// Renk listesi ve RGB kodları
export const COLOR_LIST = [
  { name: 'Ekru', hex: '#F2E8D5' },
  { name: 'Baskıaltı', hex: '#F4F4F4' },
  { name: 'Ham', hex: '#EDE8D8' },
  { name: 'Siyah', hex: '#000000' },
  { name: 'Beyaz', hex: '#FFFFFF' },
  { name: 'Optik Beyaz', hex: '#FDFDFD' },
  { name: 'Krem', hex: '#F3E7CE' },
  { name: 'Bej', hex: '#D9C7A0' },
  { name: 'Bej Açık', hex: '#E6D7B8' },
  { name: 'Bej Koyu', hex: '#C4A772' },
  { name: 'Taş', hex: '#C9C2B6' },
  { name: 'Taş Koyu', hex: '#A99F8D' },
  { name: 'Vizon', hex: '#B7A89A' },
  { name: 'Vizon Koyu', hex: '#8F8175' },
  { name: 'Vizon Açık', hex: '#D4C9BC' },
  { name: 'Camel', hex: '#C49A6C' },
  { name: 'Taba', hex: '#9C6433' },
  { name: 'Kahve', hex: '#7A4A28' },
  { name: 'Kahve Açık', hex: '#A8744F' },
  { name: 'Kahve Koyu', hex: '#4A2E1C' },
  { name: 'Kahve Tarçın', hex: '#7B5134' },
  { name: 'Karamel', hex: '#B37A3B' },
  { name: 'Tarçın', hex: '#A5642A' },
  { name: 'Bronz', hex: '#8C6239' },
  { name: 'Bej Krem', hex: '#E8DCC7' },
  { name: 'Bej Çöl', hex: '#D4C6A4' },
  { name: 'Gri', hex: '#B5B5B5' },
  { name: 'Gri Açık', hex: '#D6D6D6' },
  { name: 'Gri Koyu', hex: '#7A7A7A' },
  { name: 'Antrasit', hex: '#3A3A3A' },
  { name: 'Gümüş', hex: '#C0C0C0' },
  { name: 'Füme', hex: '#4F4F4F' },
  { name: 'Çakıl Rengi', hex: '#BAB7B0' },
  { name: 'Lacivert', hex: '#0A1A3C' },
  { name: 'Mavi', hex: '#2F6DB0' },
  { name: 'Mavi Açık', hex: '#7EB7E4' },
  { name: 'Mavi Koyu', hex: '#1F4E78' },
  { name: 'Saks', hex: '#003F87' },
  { name: 'Parlament', hex: '#1A2B7B' },
  { name: 'Mavi Buz', hex: '#CFE9F7' },
  { name: 'Mavi Bebek', hex: '#B4D9FF' },
  { name: 'Petrol', hex: '#1D4F59' },
  { name: 'Petrol Açık', hex: '#3F7C85' },
  { name: 'Petrol Koyu', hex: '#143A41' },
  { name: 'Yeşil Mint', hex: '#BFE8D8' },
  { name: 'Yeşil', hex: '#2C7A43' },
  { name: 'Yeşil Açık', hex: '#7FC88C' },
  { name: 'Yeşil Koyu', hex: '#1F5A2E' },
  { name: 'Yeşil Zümrüt', hex: '#047858' },
  { name: 'Yeşil Zeytin', hex: '#6B6A28' },
  { name: 'Yeşil Haki', hex: '#6E6B47' },
  { name: 'Yeşil Haki Açık', hex: '#A49F6C' },
  { name: 'Yeşil Fıstık', hex: '#B5D86A' },
  { name: 'Kırmızı Bayrak', hex: '#E6001A' },
  { name: 'Kırmızı', hex: '#C1121F' },
  { name: 'Kırmızı Koyu', hex: '#8B0D15' },
  { name: 'Mercan', hex: '#FF6F61' },
  { name: 'Nar Çiçeği', hex: '#FF4A4A' },
  { name: 'Bordo', hex: '#5A0F18' },
  { name: 'Bordo Şarap', hex: '#4A0D15' },
  { name: 'Turuncu', hex: '#F57C00' },
  { name: 'Turuncu Açık', hex: '#FF9A3C' },
  { name: 'Turuncu Koyu', hex: '#D56200' },
  { name: 'Turuncu Kiremit', hex: '#B65228' },
  { name: 'Hardal', hex: '#C99A00' },
  { name: 'Sarı', hex: '#F4D03F' },
  { name: 'Sarı Altın', hex: '#E2B007' },
  { name: 'Şeftali', hex: '#FFBFA0' },
  { name: 'Somon', hex: '#FFA089' },
  { name: 'Pembe', hex: '#FFB6C1' },
  { name: 'Pembe Açık', hex: '#FFD7DF' },
  { name: 'Pembe Koyu', hex: '#E67691' },
  { name: 'Pembe Toz', hex: '#F3C6CF' },
  { name: 'Pembe Pudra', hex: '#F5D7DA' },
  { name: 'Gül Kurusu', hex: '#B97A7A' },
  { name: 'Fuşya', hex: '#D5006D' },
  { name: 'Mor', hex: '#612179' },
  { name: 'Mor Açık', hex: '#9A72B4' },
  { name: 'Mor Koyu', hex: '#3D0F52' },
  { name: 'Lila', hex: '#C8A2C8' },
  { name: 'Lila Açık', hex: '#E6D5EF' },
  { name: 'Mor Lavanta', hex: '#B7A0D4' },
  { name: 'Mor Menekşe', hex: '#7A2E83' },
  { name: 'Mor Eflatun', hex: '#C39BD3' },
  { name: 'Altın', hex: '#D4AF37' },
  { name: 'Şampanya', hex: '#F7E7CE' },
  { name: 'Beyaz İnci', hex: '#FAF8F2' },
  { name: 'Puantiye', hex: '#E8E8E8' }, // Açık gri ton (noktalı desen rengi)
  { name: 'Zümrüt', hex: '#50C878' }, // Emerald green (RGB: 80, 200, 120)
  { name: 'Dijital', hex: '#FF0000' } // Çok renkli için placeholder
];

// Türkçe karakter normalizasyonu
const normalizeTurkishChars = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .replace(/ı/g, 'i')
    .replace(/ş/g, 's')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c');
};

/** Aynı renk yazımı (sadece büyük/küçük / Türkçe harf varyantı) — otomatik düzeltmede korunur */
export const areColorNamesSameSpelling = (a, b) => {
  if (a == null || b == null) return false;
  return normalizeTurkishChars(String(a).trim()) === normalizeTurkishChars(String(b).trim());
};

// Levenshtein distance algoritması
const levenshteinDistance = (str1, str2) => {
  const s1 = normalizeTurkishChars(str1);
  const s2 = normalizeTurkishChars(str2);
  
  const len1 = s1.length;
  const len2 = s2.length;
  
  if (len1 === 0) return len2;
  if (len2 === 0) return len1;
  
  const matrix = [];
  
  for (let i = 0; i <= len1; i++) {
    matrix[i] = [i];
  }
  
  for (let j = 0; j <= len2; j++) {
    matrix[0][j] = j;
  }
  
  for (let i = 1; i <= len1; i++) {
    for (let j = 1; j <= len2; j++) {
      const cost = s1[i - 1] === s2[j - 1] ? 0 : 1;
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,
        matrix[i][j - 1] + 1,
        matrix[i - 1][j - 1] + cost
      );
    }
  }
  
  return matrix[len1][len2];
};

// Ortak karakter yüzdesini hesapla (harflerin ne kadarının uyuştuğu)
const calculateCommonCharRatio = (str1, str2) => {
  const s1Norm = normalizeTurkishChars(str1);
  const s2Norm = normalizeTurkishChars(str2);
  
  if (s1Norm.length === 0 || s2Norm.length === 0) return 0;
  
  // Her iki string'deki benzersiz karakterleri say
  const chars1 = new Set(s1Norm.split(''));
  const chars2 = new Set(s2Norm.split(''));
  
  // Ortak karakterleri bul
  let commonCount = 0;
  for (const char of chars1) {
    if (chars2.has(char)) {
      commonCount++;
    }
  }
  
  // Toplam benzersiz karakter sayısı
  const totalUniqueChars = new Set([...chars1, ...chars2]).size;
  
  return totalUniqueChars > 0 ? commonCount / totalUniqueChars : 0;
};

// Kelime bazında harf uyumunu kontrol et (%60-70 uyum şartı)
const checkWordBasedMatch = (str1, str2, minMatchRatio = 0.6) => {
  const words1 = normalizeTurkishChars(str1).split(/\s+/).filter(w => w.length > 0);
  const words2 = normalizeTurkishChars(str2).split(/\s+/).filter(w => w.length > 0);
  
  // Kelime sayıları farklıysa, her kelimeyi diğer tüm kelimelerle karşılaştır
  if (words1.length !== words2.length) {
    // En az %70'i iyi eşleşmeli (daha katı kontrol)
    let goodMatches = 0;
    const totalWords = Math.max(words1.length, words2.length);
    
    // Her kelime için en iyi eşleşmeyi bul
    for (const word1 of words1) {
      let bestRatio = 0;
      for (const word2 of words2) {
        const ratio = calculateCommonCharRatio(word1, word2);
        if (ratio > bestRatio) {
          bestRatio = ratio;
        }
      }
      if (bestRatio >= minMatchRatio) {
        goodMatches++;
      }
    }
    
    // En az %70'i iyi eşleşmeli
    return goodMatches / totalWords >= 0.7;
  }
  
  // Kelime sayıları aynıysa, kelimeleri sırasız karşılaştır
  // Örnek: "koyu yeşil" vs "Yeşil Koyu" - kelimeler aynı, sadece sıra farklı
  // Her kelimeyi diğer tüm kelimelerle karşılaştır ve en iyi eşleşmeyi bul
  let goodMatches = 0;
  const usedIndices = new Set();
  
  for (const word1 of words1) {
    let bestRatio = 0;
    let bestIndex = -1;
    
    // En iyi eşleşmeyi bul
    for (let i = 0; i < words2.length; i++) {
      if (usedIndices.has(i)) continue;
      const ratio = calculateCommonCharRatio(word1, words2[i]);
      if (ratio > bestRatio) {
        bestRatio = ratio;
        bestIndex = i;
      }
    }
    
    // Eğer iyi bir eşleşme bulunduysa, kullanıldı olarak işaretle
    if (bestRatio >= minMatchRatio && bestIndex !== -1) {
      goodMatches++;
      usedIndices.add(bestIndex);
    }
  }
  
  // En az %70'i iyi eşleşmeli
  return goodMatches / words1.length >= 0.7;
};

// Benzerlik skoru hesaplama (0-1 arası, 1 = tam eşleşme)
const calculateSimilarity = (str1, str2) => {
  const distance = levenshteinDistance(str1, str2);
  const maxLen = Math.max(str1.length, str2.length);
  if (maxLen === 0) return 1;
  
  // Temel benzerlik skoru
  let similarity = 1 - (distance / maxLen);
  
  // Özel durumlar için bonus puan
  const s1Norm = normalizeTurkishChars(str1);
  const s2Norm = normalizeTurkishChars(str2);
  
  // Ortak karakter yüzdesi kontrolü - eğer %30'dan az karakter uyuşuyorsa ceza ver
  const commonCharRatio = calculateCommonCharRatio(str1, str2);
  if (commonCharRatio < 0.3) {
    similarity *= 0.3; // Çok düşük ortak karakter varsa benzerliği düşür
  }
  
  // Başlangıç karakterleri eşleşiyorsa bonus
  if (s1Norm.length > 0 && s2Norm.length > 0) {
    const firstCharMatch = s1Norm[0] === s2Norm[0];
    if (firstCharMatch) {
      similarity += 0.1;
    }
    
    // İlk 3 karakter eşleşiyorsa bonus
    const first3Match = s1Norm.substring(0, 3) === s2Norm.substring(0, 3);
    if (first3Match && s1Norm.length >= 3 && s2Norm.length >= 3) {
      similarity += 0.15;
    }
  }
  
  // Ortak karakterler varsa bonus (ama sadece yeterince ortak karakter varsa)
  if (commonCharRatio >= 0.3) {
    const commonChars = s1Norm.split('').filter(char => s2Norm.includes(char)).length;
    const totalChars = Math.max(s1Norm.length, s2Norm.length);
    if (totalChars > 0) {
      similarity += (commonChars / totalChars) * 0.1;
    }
  }
  
  return Math.min(1, Math.max(0, similarity));
};

// Renk adından RGB kodunu bul
export const getColorHex = (colorName) => {
  if (!colorName) return null;
  
  const normalized = normalizeTurkishChars(colorName);
  const exactMatch = COLOR_LIST.find(
    color => normalizeTurkishChars(color.name) === normalized
  );
  
  if (exactMatch) return exactMatch.hex;
  
  // Fuzzy matching ile en yakın eşleşmeyi bul
  const matches = COLOR_LIST.map(color => ({
    color,
    similarity: calculateSimilarity(colorName, color.name)
  })).sort((a, b) => b.similarity - a.similarity);
  
  // %80+ benzerlik varsa döndür
  if (matches.length > 0 && matches[0].similarity >= 0.8) {
    return matches[0].color.hex;
  }
  
  return null;
};

// Renk önerileri getir (max 5)
export const getColorSuggestions = (searchTerm, maxResults = 5) => {
  if (!searchTerm || searchTerm.trim().length === 0) {
    return COLOR_LIST.slice(0, maxResults);
  }
  
  const normalizedSearch = normalizeTurkishChars(searchTerm);
  const searchLength = normalizedSearch.length;
  
  const matches = COLOR_LIST.map(color => {
    const normalizedColor = normalizeTurkishChars(color.name);
    const colorLength = normalizedColor.length;
    
    // Karakter uzunluğu farkı kontrolü
    const lengthDiff = Math.abs(searchLength - colorLength);
    const avgLength = (searchLength + colorLength) / 2;
    const lengthDiffPercent = avgLength > 0 ? (lengthDiff / avgLength) * 100 : 0;
    
    // Eğer karakter uzunluğu farkı %50'den fazlaysa, bu eşleşmeyi atla
    if (lengthDiffPercent > 50) {
      return null;
    }
    
    // Ortak karakter yüzdesi kontrolü
    const commonCharRatio = calculateCommonCharRatio(searchTerm, color.name);
    
    // Eğer ortak karakter yüzdesi %30'dan azsa, bu eşleşmeyi atla
    if (commonCharRatio < 0.3) {
      return null;
    }
    
    // Kelime bazında harf uyumu kontrolü (%60-70 uyum şartı)
    const wordMatch = checkWordBasedMatch(searchTerm, color.name, 0.6);
    if (!wordMatch) {
      return null;
    }
    
    const similarity = calculateSimilarity(searchTerm, color.name);
    const startsWith = normalizedColor.startsWith(normalizedSearch);
    
    return {
      color,
      similarity,
      startsWith,
      lengthDiffPercent,
      commonCharRatio
    };
  }).filter(match => match !== null && (match.similarity > 0.5 || match.startsWith))
    .sort((a, b) => {
      // Önce başlayanları, sonra benzerlik skoruna göre sırala
      if (a.startsWith && !b.startsWith) return -1;
      if (!a.startsWith && b.startsWith) return 1;
      return b.similarity - a.similarity;
    })
    .slice(0, maxResults);
  
  // Eğer en iyi eşleşme %50'ten düşükse ve başlangıç eşleşmesi de yoksa, öneri üretme
  if (matches.length > 0) {
    const bestMatch = matches[0];
    if (bestMatch.similarity <= 0.5 && !bestMatch.startsWith) {
      return [];
    }
  }
  
  return matches.map(match => match.color);
};

// Kelimeleri sıralı olarak karşılaştır (kelime sırası önemli değil)
const compareWords = (words1, words2) => {
  const sorted1 = [...words1].sort().join(' ');
  const sorted2 = [...words2].sort().join(' ');
  return sorted1 === sorted2;
};

// En yakın renk adını bul (yazım hatası düzeltme için)
// minSimilarity: Minimum benzerlik eşiği (0.8 = %80)
// Eğer girilen renk hiçbir renkle %80'ten düşük benzerlikteyse null döner (özel renk olarak kabul edilir)
export const findClosestColorName = (colorName, minSimilarity = 0.8) => {
  if (!colorName) return null;
  
  const normalizedSearch = normalizeTurkishChars(colorName);
  const searchWords = normalizedSearch.split(/\s+/).filter(w => w.length > 0);
  const searchWordCount = searchWords.length;
  
  const matches = COLOR_LIST.map(color => {
    const normalizedColor = normalizeTurkishChars(color.name);
    const colorWords = normalizedColor.split(/\s+/).filter(w => w.length > 0);
    const colorWordCount = colorWords.length;
    
    // 1. Kelime sayısı eşleşmesi kontrolü (öncelikli)
    const wordCountMatch = searchWordCount === colorWordCount;
    
    // 2. Kelime sırası kontrolü (kelimeler aynı mı, sıra farklı mı)
    const wordsMatch = compareWords(searchWords, colorWords);
    
    // 3. Temel benzerlik hesaplama
    let similarity = calculateSimilarity(colorName, color.name);
    
    // Özel durumlar için bonus
    let bonus = 0;
    
    // Eğer kelimeler eşleşiyorsa (sadece sıra farklıysa), benzerlik skorunu yüksek yap
    if (wordsMatch && wordCountMatch) {
      // Kelimeler aynı, sadece sıra farklı - benzerlik skorunu otomatik olarak yüksek yap
      similarity = Math.max(similarity, 0.85); // En az %85 benzerlik
      bonus += 0.2; // Ek bonus
    } else {
      // Kelime sayısı eşleşiyorsa büyük bonus
      if (wordCountMatch) {
        bonus += 0.3;
      } else {
        // Kelime sayısı eşleşmiyorsa ceza
        const wordCountDiff = Math.abs(searchWordCount - colorWordCount);
        bonus -= wordCountDiff * 0.2;
      }
      
      // Kelimeler eşleşiyorsa (sıra farklı olsa bile) bonus
      if (wordsMatch) {
        bonus += 0.25;
      }
    }
    
    // "baskılatı" → "baskıaltı" gibi durumlar için
    // Karakterlerin çoğu eşleşiyorsa ve uzunluklar yakınsa bonus ver
    if (Math.abs(normalizedSearch.length - normalizedColor.length) <= 2) {
      const charDiff = Math.abs(normalizedSearch.length - normalizedColor.length);
      if (charDiff <= 1) {
        bonus += 0.1;
      }
    }
    
    // İçeriyor mu kontrolü (tek yönlü) - ama kelime sayısı eşleşiyorsa
    if (wordCountMatch) {
      if (normalizedColor.includes(normalizedSearch) || normalizedSearch.includes(normalizedColor)) {
        bonus += 0.15;
      }
    }
    
    // İlk 3 karakter eşleşiyorsa ekstra bonus
    if (normalizedSearch.length >= 3 && normalizedColor.length >= 3) {
      if (normalizedSearch.substring(0, 3) === normalizedColor.substring(0, 3)) {
        bonus += 0.1;
      }
    }
    
    return {
      name: color.name,
      similarity: Math.min(1, Math.max(0, similarity + bonus)),
      wordCountMatch,
      wordsMatch
    };
  }).sort((a, b) => {
    // Önce kelime sayısı eşleşmesine göre sırala
    if (a.wordCountMatch !== b.wordCountMatch) {
      return b.wordCountMatch ? 1 : -1;
    }
    // Sonra kelime eşleşmesine göre
    if (a.wordsMatch !== b.wordsMatch) {
      return b.wordsMatch ? 1 : -1;
    }
    // Son olarak benzerlik skoruna göre
    return b.similarity - a.similarity;
  });
  
  // En iyi eşleşmeyi bul
  const bestMatch = matches[0];
  
  if (bestMatch && bestMatch.similarity >= minSimilarity) {
    // Ek kontrol: Karakter uzunluğu farkı çok büyükse düzeltme yapma
    // Örnek: "rotasyon" (8 karakter) → "Taş" (3 karakter) = %62.5 fark → düzeltme yapma
    const lengthDiff = Math.abs(normalizedSearch.length - normalizeTurkishChars(bestMatch.name).length);
    const avgLength = (normalizedSearch.length + normalizeTurkishChars(bestMatch.name).length) / 2;
    const lengthDiffPercent = avgLength > 0 ? (lengthDiff / avgLength) * 100 : 0;
    
    // Eğer karakter uzunluğu farkı %50'den fazlaysa düzeltme yapma
    if (lengthDiffPercent > 50) {
      return null;
    }
    
    // Ek kontrol: Girilen kelime çok kısa (2 karakter veya daha az) ve bulunan renk çok uzunsa düzeltme yapma
    if (normalizedSearch.length <= 2 && normalizeTurkishChars(bestMatch.name).length > 4) {
      return null;
    }
    
    // Eğer kelimeler eşleşiyor ama sıra farklıysa, kelime bazında kontrolü atla ve doğru sırayı döndür
    if (bestMatch.wordsMatch && bestMatch.wordCountMatch && searchWordCount > 1) {
      // Kelimeler aynı, sadece sıra farklı - kontrolü atla ve düzeltmeyi yap
    } else {
      // Kelime bazında harf uyumu kontrolü (%60-70 uyum şartı)
      const wordMatch = checkWordBasedMatch(colorName, bestMatch.name, 0.6);
      if (!wordMatch) {
        return null;
      }
    }
    
    // Eğer kelimeler eşleşiyor ama sıra farklıysa, doğru sırayı döndür
    if (bestMatch.wordsMatch && bestMatch.wordCountMatch && searchWordCount > 1) {
      // Kelime sırasını düzelt
      // Örnek: "koyu kırmızı" → "Kırmızı Koyu"
      const originalColorWords = bestMatch.name.split(/\s+/);
      const normalizedColorWords = originalColorWords.map(w => normalizeTurkishChars(w));
      
      // Girilen kelimeleri orijinal renk adındaki sıraya göre yeniden sırala
      const reorderedWords = [];
      const usedSearchIndices = new Set();
      
      // Orijinal renk adındaki kelime sırasını takip et
      for (let colorIndex = 0; colorIndex < normalizedColorWords.length; colorIndex++) {
        const normalizedColorWord = normalizedColorWords[colorIndex];
        
        // Girilen kelimelerden hangisi bu kelimeye en yakın?
        let bestWordIndex = -1;
        let bestWordSimilarity = 0;
        
        for (let i = 0; i < searchWords.length; i++) {
          if (usedSearchIndices.has(i)) continue; // Zaten kullanıldı
          
          const similarity = calculateSimilarity(searchWords[i], normalizedColorWord);
          if (similarity > bestWordSimilarity && similarity > 0.5) {
            bestWordSimilarity = similarity;
            bestWordIndex = i;
          }
        }
        
        if (bestWordIndex >= 0) {
          // Orijinal renk adındaki kelimeyi kullan (büyük/küçük harf korunur)
          reorderedWords.push(originalColorWords[colorIndex]);
          usedSearchIndices.add(bestWordIndex);
        }
      }
      
      // Eğer tüm kelimeler eşleştiyse, yeniden sıralanmış versiyonu döndür
      if (reorderedWords.length === originalColorWords.length) {
        return reorderedWords.join(' ');
      }
    }
    
    return bestMatch.name;
  }
  
  return null;
};

/**
 * Medianteg / otomatik doldurma: sözlükte yeterince yakın eşleşme varsa standart renk adını döner.
 * Manuel kutuda ColorInput aynı yazımı koruyabilir; içe aktarılan ham metin burada normalize edilir.
 */
export const resolveColorFromLookup = (raw, minSimilarity = 0.8) => {
  const trimmed = String(raw ?? '').trim();
  if (!trimmed) return '';
  const closest = findClosestColorName(trimmed, minSimilarity);
  return closest != null ? closest : trimmed;
};
